import { useMutation } from 'react-query';

import { getRelatedActivity as mutationFn } from 'api/endPoints/getRelatedActivity';

export const useMutationGetCardDates = () => {
    return useMutation<IGetCardDatesResponse, QueryError, IGetCardDatesPayload>((params) => mutationFn(params));
};

interface IGetCardDatesPayload {
    taskId: number;
}

interface IGetCardDatesResponse {
    activityId: string;
    activityName: string;
    activityStatus: null;
    activityType: string;
    actualFinishDate: null;
    actualStartDate: number;
    calculatedFinishDate: number;
    calculatedStartDate: number;
    criticalPath: boolean;
    criticalityScore: number;
    delayDriver: boolean;
    id: number;
    isImportant: boolean;
    plannedFinishDate: number;
    plannedStartDate: number;
    projectWeekFinish: number;
    projectWeekStart: number;
    wbsCode: string;
    wbsId: number;
    wbsLevel: number;
    wbsName: string;
}
